(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-with-text"] && !Shopify.designMode) return;
  try {
    
  // AIRIVO 03：结束时显示封面，重播实际开始后撤下封面。
  // 监听实际视频元素的结束事件。播放、暂停和续播仍由 Concept 管理。
  document.addEventListener('ended', (event) => {
    const video = event.target;
    if (!(video instanceof HTMLVideoElement) || video.loop) return;

    const media = video.parentElement;
    if (!media?.matches('.airivo-manual-video video-media:not([host])')) return;

    if (video.poster) {
      media.style.setProperty('--airivo-video-preview', 'url(' + JSON.stringify(video.poster) + ')');
    }
    media.removeAttribute('playing');
    // AIRIVO 06：仅在结束状态撤下浏览器原生控件，并记住原设置。
    video.toggleAttribute('data-airivo-restore-controls', video.controls);
    video.controls = false;
    media.setAttribute('data-airivo-ended', '');
    media.posterElement?.setAttribute('aria-label', 'Replay video');
  }, true);

  document.addEventListener('playing', (event) => {
    const video = event.target;
    if (!(video instanceof HTMLVideoElement)) return;

    const media = video.parentElement;
    if (media?.matches('.airivo-manual-video video-media[data-airivo-ended]')) {
      media.removeAttribute('data-airivo-ended');
      video.controls = video.hasAttribute('data-airivo-restore-controls');
      video.removeAttribute('data-airivo-restore-controls');
    }
  }, true);

  } catch(e) { console.error(e); }
})();
})();
